// Wrapper component to handle Suspense for lazy-loaded components
import { ReactNode, Suspense } from "react"
import { LoadingFallback } from "@/components/app/LoadingFallback.tsx"

export const SuspenseWrapper = ({
  children,
}: {
  children: ReactNode
}) => <Suspense fallback={<LoadingFallback />}>{children}</Suspense>
